import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 22H12.5C12.6326 22 12.7598 21.9473 12.8535 21.8536C12.9473 21.7598 13 21.6326 13 21.5V5.33L17.44 9.78C17.4856 9.82656 17.5401 9.86356 17.6002 9.88881C17.6603 9.91406 17.7248 9.92707 17.79 9.92707C17.8552 9.92707 17.9197 9.91406 17.9798 9.88881C18.0399 9.86356 18.0944 9.82656 18.14 9.78L18.85 9.07C18.8968 9.02352 18.934 8.96822 18.9594 8.90729C18.9848 8.84636 18.9979 8.78101 18.9979 8.715C18.9979 8.64899 18.9848 8.58364 18.9594 8.52271C18.934 8.46178 18.8968 8.40648 18.85 8.36L12.72 2.22C12.5783 2.08112 12.3884 2.0023 12.19 2H11.81C11.6111 2.00018 11.4205 2.07931 11.28 2.22L5.14997 8.36C5.10311 8.40648 5.06591 8.46178 5.04053 8.52271C5.01514 8.58364 5.00208 8.64899 5.00208 8.715C5.00208 8.78101 5.01514 8.84636 5.04053 8.90729C5.06591 8.96822 5.10311 9.02352 5.14997 9.07L5.84997 9.78C5.89646 9.82686 5.95176 9.86406 6.01269 9.88945C6.07362 9.91483 6.13897 9.9279 6.20497 9.9279C6.27098 9.9279 6.33633 9.91483 6.39726 9.88945C6.45819 9.86406 6.51349 9.82686 6.55997 9.78L11 5.33V21.5C11 21.6326 11.0527 21.7598 11.1464 21.8536C11.2402 21.9473 11.3674 22 11.5 22Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgUpwardOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgUpwardOutline;
